// import '../../style/index.scss';
import App from "./components";

export default App;
// puuuuuu
